import * as React from "react";
import { Text } from "react-native-paper";
import PageContainer from "../../common/PageContainer";
import routes from "../../routing/routes";
import { StyleSheet, View } from "react-native";
import NavigationAboutColorsBox from "../../common/NavigationAboutColorsBox";
import t from "../../translations";

export default (props) => {
  const onClickGoToSettings = () => {
    props.navigation.navigate(routes.Settings);
  };
  return (
    <PageContainer
      {...props}
      onClickGoToSettings={onClickGoToSettings}
      isSettingsIcon={true}
      noBackground={true}
    >
      <View style={styles.container}>
        <Text style={styles.title}>{t('aboutColors_title')}</Text>
        <NavigationAboutColorsBox {...props} />
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "flex-start",
    width: "100%",
    height: "100%",
  },
  title: {
    textTransform: "uppercase",
    fontSize: 24,
    fontWeight: "400",
    lineHeight: 26,
    letterSpacing: 1.25,
    padding: 20,
    textAlign: "center",
    color: "black",
  },
});
